import { environment } from '@environment';

/**
 * Etiqueta de versión para mostrar al usuario: `v1.2.3 (600)`. Versión y build los sella el pipeline en el
 * environment; en local queda `v0.0.0-local (1)`.
 */
export function appVersionLabel(): string {
  return `v${environment.appVersion} (${environment.appBuild})`;
}
